import { DespatchAdvice } from '../../data/models'
import i18n from '../../utils/i18n'

export const DeliveryTypeBodyTemplate = (
  deliveryType: DespatchAdvice['DeliveryType'],
) => {
  if (!deliveryType) return null

  return (
    <>
      {deliveryType === 'FULL'
        ? i18n.t('common.codes.deliveryType.full')
        : i18n.t('common.codes.deliveryType.partly')}
    </>
  )
}
